export default __webpack_public_path__ + "static/media/light-theme-google-cloud-logo.63abc390.svg";